/* NOVA – Animationen (GSAP + ScrollTrigger) und Shop-Logik */
(function () {
  "use strict";

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var hasGsap = typeof window.gsap !== "undefined" && typeof window.ScrollTrigger !== "undefined";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (hasGsap) {
    gsap.registerPlugin(ScrollTrigger);
    gsap.defaults({ ease: "expo.out", duration: 1.1 });
    ScrollTrigger.config({ ignoreMobileResize: true });
  }

  /* ---------------- Header ---------------- */
  function initHeader() {
    var header = $("[data-header]");
    if (!header) return;
    var lastY = window.scrollY;
    var ticking = false;
    function update() {
      var y = window.scrollY;
      header.classList.toggle("is-scrolled", y > 8);
      if (!header.classList.contains("menu-open")) {
        header.classList.toggle("is-hidden", y > 420 && y > lastY);
      }
      lastY = y;
      ticking = false;
    }
    window.addEventListener("scroll", function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();

    var toggle = $("[data-menu-toggle]", header);
    var menu = $("[data-menu]", header);
    if (!toggle || !menu) return;
    function setOpen(open) {
      toggle.setAttribute("aria-expanded", String(open));
      header.classList.toggle("menu-open", open);
      document.body.style.overflow = open ? "hidden" : "";
      if (open) {
        menu.hidden = false;
        if (hasGsap && !reduce) {
          gsap.fromTo(menu, { opacity: 0 }, { opacity: 1, duration: 0.4, ease: "power2.out" });
          gsap.fromTo($$(".site-menu__link", menu), { yPercent: 110, opacity: 0 }, { yPercent: 0, opacity: 1, stagger: 0.06, duration: 0.9 });
        }
      } else {
        menu.hidden = true;
      }
    }
    toggle.addEventListener("click", function () { setOpen(toggle.getAttribute("aria-expanded") !== "true"); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && header.classList.contains("menu-open")) { setOpen(false); toggle.focus(); } });
  }

  /* ---------------- Hero: der eine große Moment ---------------- */
  function initHero() {
    var hero = $("[data-hero]");
    if (!hero) return;
    $$(".hero__stage, .hero__foot", hero).forEach(function (el) { el.style.visibility = "visible"; });
    if (!hasGsap) return;
    var letters = $$("[data-hero-letter]", hero);
    var star = $("[data-hero-star] svg", hero);
    var product = $("[data-hero-product]", hero);
    var foot = $(".hero__foot", hero);

    if (reduce) return;

    var intro = gsap.timeline({ delay: 0.15 });
    intro
      .from(letters, { yPercent: 115, duration: 1.3, stagger: 0.07 })
      .from(star, { scale: 0.2, rotation: -120, opacity: 0, duration: 1.6, ease: "expo.out", transformOrigin: "50% 50%" }, 0.25)
      .from(product, { y: 140, opacity: 0, scale: 0.92, duration: 1.5, ease: "expo.out" }, 0.45)
      .from(foot ? foot.children : [], { y: 24, opacity: 0, stagger: 0.08, duration: 0.9 }, 0.9);

    // Leerlauf: Stern dreht sich langsam, Produkt schwebt
    gsap.to(star, { rotation: "+=360", duration: 60, ease: "none", repeat: -1, transformOrigin: "50% 50%" });
    var img = product && product.querySelector("img");
    if (img) gsap.to(img, { y: -14, duration: 3.2, ease: "sine.inOut", yoyo: true, repeat: -1 });

    // Beim Scrollen: Buchstaben gehen auseinander, Produkt hebt ab
    var out = gsap.timeline({
      scrollTrigger: { trigger: hero, start: "top top", end: "bottom top", scrub: 0.8 }
    });
    letters.forEach(function (el, i) {
      var side = el.getAttribute("data-side") === "l" ? -1 : 1;
      var dist = (Math.abs(i - (letters.length - 1) / 2) + 0.5) * 22;
      out.to(el, { xPercent: side * dist, ease: "none" }, 0);
    });
    out
      .to(product, { yPercent: -18, scale: 0.86, ease: "none" }, 0)
      .to(star, { scale: 1.7, opacity: 0, ease: "none" }, 0);
  }

  /* ---------------- Horizontaler Drop ---------------- */
  function initDrop() {
    $$("[data-drop]").forEach(function (section) {
      if (section.getAttribute("data-drop") !== "pin" || !hasGsap) { initDropNav(section); return; }
      var track = $("[data-drop-track]", section);
      var pin = $("[data-drop-pin]", section);
      var bar = $("[data-drop-progress]", section);
      var mm = gsap.matchMedia();
      mm.add("(prefers-reduced-motion: no-preference)", function () {
        section.classList.add("is-pinned");
        var distance = function () { return Math.max(0, track.scrollWidth - track.parentElement.clientWidth); };
        var tween = gsap.to(track, {
          x: function () { return -distance(); },
          ease: "none",
          scrollTrigger: {
            trigger: pin,
            pin: true,
            start: "top top",
            end: function () { return "+=" + distance(); },
            scrub: 0.6,
            invalidateOnRefresh: true,
            onUpdate: function (self) { if (bar) gsap.set(bar, { scaleX: self.progress }); }
          }
        });
        // Karten kippen leicht mit der Scroll-Geschwindigkeit
        var cards = $$(".drop__item .product-card__media img:first-child", section);
        var skewTo = cards.map(function (c) { return gsap.quickTo(c, "rotation", { duration: 0.6, ease: "power3.out" }); });
        var st = tween.scrollTrigger;
        var tick = function () {
          var v = gsap.utils.clamp(-6, 6, st.getVelocity() / -260);
          skewTo.forEach(function (fn) { fn(v); });
        };
        gsap.ticker.add(tick);
        return function () {
          gsap.ticker.remove(tick);
          section.classList.remove("is-pinned");
          gsap.set(track, { clearProps: "transform" });
        };
      });
    });
  }

  // Normales Wischen + Pfeile (Desktop)
  function initDropNav(section) {
    var viewport = $(".drop__viewport", section);
    var prev = $("[data-drop-prev]", section);
    var next = $("[data-drop-next]", section);
    if (!viewport || !prev || !next) return;
    var step = function () { var item = $(".drop__item", section); return item ? item.getBoundingClientRect().width + 20 : viewport.clientWidth * 0.8; };
    var update = function () {
      prev.disabled = viewport.scrollLeft <= 4;
      next.disabled = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 4;
    };
    prev.addEventListener("click", function () { viewport.scrollBy({ left: -step(), behavior: "smooth" }); });
    next.addEventListener("click", function () { viewport.scrollBy({ left: step(), behavior: "smooth" }); });
    viewport.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  /* ---------------- Statement: Wörter füllen sich beim Scrollen ---------------- */
  function initStatement() {
    $$("[data-statement-text]").forEach(function (el) {
      var esc = function (w) { return w.replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
      el.innerHTML = el.textContent.trim().split(/\n+/).map(function (line) {
        return line.trim().split(/\s+/).map(function (w) { return '<span class="w">' + esc(w) + "</span>"; }).join(" ");
      }).join("<br>");
      if (!hasGsap || reduce) return;
      gsap.to($$(".w", el), {
        color: "#16171a",
        stagger: 0.12,
        ease: "none",
        scrollTrigger: { trigger: el, start: "top 78%", end: "bottom 42%", scrub: true }
      });
    });
  }

  /* ---------------- Kategorien: Bild folgt dem Mauszeiger ---------------- */
  function initCategoriesTouch() {
    if (!hasGsap || reduce || window.matchMedia("(hover: hover)").matches) return;
    $$("[data-cats]").forEach(function (section) {
      var links = $$("[data-cat-link]", section);
      section.classList.add("is-scrolly");
      links.forEach(function (link) {
        var img = $(".cats__img", link);
        ScrollTrigger.create({
          trigger: link,
          start: "top 50%",
          end: "bottom 50%",
          onToggle: function (self) {
            link.classList.toggle("is-active", self.isActive);
            if (img) {
              gsap.to(img, self.isActive
                ? { x: 0, rotation: 0, opacity: 1, scale: 1, duration: 0.8, ease: "expo.out", overwrite: true }
                : { x: 40, rotation: 12, opacity: 0, scale: 0.7, duration: 0.5, ease: "power2.out", overwrite: true });
            }
          }
        });
        if (img) gsap.set(img, { x: 40, rotation: 12, opacity: 0, scale: 0.7 });
      });
    });
  }

  function initCategories() {
    $$("[data-cats]").forEach(function (section) {
      var follower = $("[data-cat-follower]", section);
      if (!follower || !hasGsap || !window.matchMedia("(hover: hover)").matches) return;
      var xTo = gsap.quickTo(follower, "x", { duration: 0.6, ease: "power3.out" });
      var yTo = gsap.quickTo(follower, "y", { duration: 0.6, ease: "power3.out" });
      var rTo = gsap.quickTo(follower, "rotation", { duration: 0.8, ease: "power3.out" });
      var lastX = 0;
      var current = null;
      function show(link) {
        var src = link && $(".cats__img img", link);
        current = link;
        if (!src) { hide(); return; }
        follower.innerHTML = "";
        follower.appendChild(src.cloneNode(true));
        gsap.to(follower, { opacity: 1, scale: 1, duration: 0.6, ease: "expo.out", overwrite: "auto" });
      }
      function hide() {
        current = null;
        gsap.to(follower, { opacity: 0, scale: 0.6, duration: 0.4, ease: "power2.in", overwrite: "auto" });
      }
      section.addEventListener("pointermove", function (e) {
        xTo(e.clientX); yTo(e.clientY);
        rTo(gsap.utils.clamp(-12, 12, (e.clientX - lastX) * 0.6));
        lastX = e.clientX;
        var link = e.target.closest ? e.target.closest("[data-cat-link]") : null;
        if (link !== current) { if (link) show(link); else hide(); }
      });
      section.addEventListener("pointerleave", hide);
      window.addEventListener("scroll", function () { if (current) hide(); }, { passive: true });
    });
  }

  /* ---------------- Produktbilder schweben beim Scrollen ---------------- */
  function initParallax() {
    if (!hasGsap || reduce) return;
    $$(".product-grid .product-card__media").forEach(function (media) {
      var img = media.querySelector("img");
      if (!img) return;
      gsap.fromTo(img, { yPercent: 7 }, {
        yPercent: -7, ease: "none",
        scrollTrigger: { trigger: media, start: "top bottom", end: "bottom top", scrub: true }
      });
    });
  }

  /* ---------------- Footer: Wortmarke steigt auf ---------------- */
  function initFooter() {
    var word = $("[data-footer-word]");
    if (!word || !hasGsap || reduce) return;
    var letters = $$("[data-footer-letter]", word);
    gsap.set(letters, { yPercent: 105 });
    ScrollTrigger.create({
      trigger: word,
      start: "top 92%",
      once: true,
      onEnter: function () { gsap.to(letters, { yPercent: 0, stagger: 0.08, duration: 1.4, ease: "expo.out" }); }
    });
  }

  /* ---------------- Produktseite: mitlaufende Kaufleiste (mobil) ---------------- */
  function initStickyBuy() {
    var bar = $("[data-sticky-buy]");
    var main = $("[data-add]");
    if (!bar || !main || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var hidden = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      bar.classList.toggle("is-visible", hidden);
      bar.setAttribute("aria-hidden", String(!hidden));
    });
    io.observe(main);
    $("[data-sticky-add]", bar).addEventListener("click", function () { main.click(); });
  }

  /* ---------------- Reveal für Produktraster ---------------- */
  function initReveal() {
    var items = $$("[data-reveal]");
    if (!items.length) return;
    if (!hasGsap || reduce) { items.forEach(function (el) { el.style.opacity = 1; }); return; }
    gsap.set(items, { y: 48 });
    ScrollTrigger.batch(items, {
      start: "top 90%",
      once: true,
      onEnter: function (batch) { gsap.to(batch, { opacity: 1, y: 0, stagger: 0.08, duration: 1.2, overwrite: true }); }
    });
  }

  /* ---------------- Produktseite ---------------- */
  function initProduct() {
    var root = $("[data-product]");
    if (!root) return;
    var dataEl = $("[data-product-json]", root);
    var data = dataEl ? JSON.parse(dataEl.textContent) : { variants: [], t: {} };
    var form = $("[data-product-form]", root);
    var idInput = $("[data-variant-id]", root);
    var addBtn = $("[data-add]", root);
    var addLabel = $("[data-add-label]", root);
    var priceEl = $("[data-price]", root);
    var status = $("[data-status]", root);
    var gallery = $("[data-gallery]", root);
    var note = $("[data-limit-note]", root);
    var qty = $('input[name="quantity"]', root);
    var stickyLabel = $("[data-sticky-label]");
    var stickyPrice = $("[data-sticky-price]");
    var stickyBtn = $("[data-sticky-add]");
    var maxItems = parseInt(root.getAttribute("data-max"), 10) || 0;
    var inCart = parseInt(root.getAttribute("data-count"), 10) || 0;
    var variant = null;
    var busy = false;

    function setLabel(text) { addLabel.textContent = text; if (stickyLabel) stickyLabel.textContent = text; }
    function setDisabled(state) { addBtn.disabled = state; if (stickyBtn) stickyBtn.disabled = state; }
    function room() { return maxItems > 0 ? Math.max(0, maxItems - inCart) : Infinity; }
    function clampQty() {
      var r = room();
      var v = parseInt(qty.value, 10) || 1;
      if (r !== Infinity) {
        qty.max = String(Math.max(1, r));
        v = Math.min(v, Math.max(1, r));
      }
      qty.value = Math.max(1, v);
    }

    // Zeigt den richtigen Zustand von Button und Hinweis
    function render() {
      clampQty();
      var express = $(".shopify-payment-button", root);
      if (express) express.hidden = maxItems > 0 && room() === 0;
      if (!variant) { setDisabled(true); setLabel(data.t.unavailable); return; }
      if (maxItems > 0 && room() === 0) {
        setDisabled(true);
        setLabel(data.t.cartFull);
        if (note) {
          note.classList.add("is-full");
          note.innerHTML = data.t.limitFull + ' <a href="/cart">' + data.t.viewCart + "</a>";
        }
        return;
      }
      setDisabled(!variant.available || busy);
      setLabel(variant.available ? data.t.add : data.t.soldOut);
      if (note && maxItems > 0 && inCart > 0) {
        note.classList.remove("is-full");
        var r = room();
        note.textContent = (r === 1 ? data.t.limitOne : data.t.limitOther).replace("999", r);
      }
    }

    function selected() {
      var opts = [];
      $$("input[data-option-index]:checked", root).forEach(function (input) {
        opts[Number(input.getAttribute("data-option-index"))] = input.value;
      });
      return opts;
    }
    function findVariant(opts) {
      if (!data.variants.length) return null;
      if (!opts.length) return data.variants[0];
      return data.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); }) || null;
    }
    function onVariantChange() {
      var opts = selected();
      opts.forEach(function (val, i) {
        var label = $('[data-option-value="' + i + '"]', root);
        if (label) label.textContent = val;
      });
      variant = findVariant(opts);
      render();
      if (!variant) return;
      idInput.value = variant.id;
      if (stickyPrice) stickyPrice.textContent = variant.price;
      priceEl.innerHTML = (variant.compare ? "<s>" + variant.compare + "</s>" : "") + "<span>" + variant.price + "</span>";
      var url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      window.history.replaceState({}, "", url.toString());
      if (variant.media && gallery) {
        var fig = $('[data-media-id="' + variant.media + '"]', gallery);
        if (fig) {
          if (window.matchMedia("(max-width: 989px)").matches) gallery.scrollTo({ left: fig.offsetLeft, behavior: reduce ? "auto" : "smooth" });
          else fig.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "center" });
        }
      }
    }
    $$("input[data-option-index]", root).forEach(function (input) { input.addEventListener("change", onVariantChange); });

    // Startzustand
    variant = data.variants.find(function (v) { return String(v.id) === String(idInput.value); }) || findVariant(selected());
    render();

    // Menge (begrenzt auf den freien Platz im Warenkorb)
    $$("[data-qty]", root).forEach(function (btn) {
      btn.addEventListener("click", function () {
        qty.value = (parseInt(qty.value, 10) || 1) + Number(btn.getAttribute("data-qty"));
        clampQty();
      });
    });
    qty.addEventListener("change", clampQty);

    // Bildzähler (mobil)
    var counter = $("[data-gallery-index]", root);
    if (gallery && counter) {
      gallery.addEventListener("scroll", function () {
        counter.textContent = Math.round(gallery.scrollLeft / gallery.clientWidth) + 1;
      }, { passive: true });
    }

    // In den Warenkorb ohne Seitenwechsel
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        if (addBtn.disabled || busy) return;
        clampQty();
        var amount = parseInt(qty.value, 10) || 1;
        if (amount > room()) { render(); return; }
        busy = true;
        setDisabled(true);
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: amount }] })
        })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function () {
            inCart += amount;
            addBtn.classList.add("is-added");
            setLabel(data.t.added);
            if (hasGsap && !reduce) gsap.fromTo(addBtn, { scale: 0.96 }, { scale: 1, duration: 0.7, ease: "elastic.out(1, 0.5)" });
            status.innerHTML = '<a href="/cart">' + data.t.viewCart + "</a>";
            refreshCartCount();
            setTimeout(function () {
              busy = false;
              addBtn.classList.remove("is-added");
              qty.value = 1;
              render();
            }, 1600);
          })
          .catch(function (err) {
            busy = false;
            status.textContent = (err && (err.description || err.message)) || data.t.unavailable;
            render();
          });
      });
    }
  }

  function refreshCartCount() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$("[data-cart-count]").forEach(function (el) {
          var changed = el.textContent !== String(cart.item_count);
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
          if (changed && hasGsap && !reduce) gsap.fromTo(el, { scale: 0.4 }, { scale: 1, duration: 0.8, ease: "elastic.out(1, 0.45)" });
        });
        return cart;
      });
  }

  /* ---------------- Warenkorb: Plus/Minus, ohne Neuladen ---------------- */
  function initCart() {
    var root = $("[data-cart-root]");
    if (!root) return;
    var sectionId = root.getAttribute("data-section");
    var maxItems = parseInt(root.getAttribute("data-max"), 10) || 0;
    var count = parseInt(root.getAttribute("data-count"), 10) || 0;

    function change(line, quantity) {
      root.classList.add("is-busy");
      var before = count;
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line: line, quantity: quantity, sections: [sectionId], sections_url: "/cart" })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (res) {
          var html = res.sections && res.sections[sectionId];
          if (!html) { window.location.reload(); return; }
          var doc = new DOMParser().parseFromString(html, "text/html");
          var fresh = doc.querySelector("[data-cart-root]");
          if (!fresh) { window.location.reload(); return; }
          root.replaceWith(fresh);
          refreshCartCount();
          initCart();
          // Neu gefülltes Kästchen kurz aufploppen lassen
          var now = parseInt(fresh.getAttribute("data-count"), 10) || 0;
          if (hasGsap && !reduce && now > before) {
            var filled = $$(".limit__slot.is-filled", fresh);
            var last = filled[filled.length - 1];
            if (last) gsap.fromTo(last, { scale: 0.3 }, { scale: 1, duration: 0.7, ease: "elastic.out(1, 0.5)" });
          }
        })
        .catch(function () { window.location.reload(); });
    }

    $$("[data-step]", root).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var step = Number(btn.getAttribute("data-step"));
        var current = parseInt(btn.getAttribute("data-qty"), 10) || 0;
        if (step > 0 && maxItems > 0 && count >= maxItems) return;
        change(Number(btn.getAttribute("data-line")), Math.max(0, current + step));
      });
    });

    $$(".stepper__input", root).forEach(function (input) {
      input.addEventListener("change", function () {
        var line = Number(input.getAttribute("data-line"));
        var wanted = Math.max(0, parseInt(input.value, 10) || 0);
        var max = parseInt(input.getAttribute("max"), 10);
        if (!isNaN(max)) wanted = Math.min(wanted, max);
        input.value = wanted;
        change(line, wanted);
      });
    });

    $$("[data-remove]", root).forEach(function (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        change(Number(link.getAttribute("data-line")), 0);
      });
    });
  }

  /* ---------------- Collection: Sortierung ---------------- */
  function initSort() {
    var select = $("[data-sort]");
    if (!select) return;
    select.addEventListener("change", function () {
      var url = new URL(window.location.href);
      url.searchParams.set("sort_by", select.value);
      url.searchParams.delete("page");
      window.location.href = url.toString();
    });
  }

  function init() {
    initHeader();
    initHero();
    initDrop();
    initStatement();
    initCategories();
    initCategoriesTouch();
    initReveal();
    initParallax();
    initFooter();
    initStickyBuy();
    initProduct();
    initSort();
    initCart();
    if (hasGsap) {
      window.addEventListener("load", function () { ScrollTrigger.refresh(); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { ScrollTrigger.refresh(); });
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
